<template>
<div>

  <router-view/>

</div>

</template>
<script>

export default {
  name: 'app',

  computed: {
    currentUser() {
      return this.$store.state.auth.user;
    },
  },

}

</script>
<style>
@import "assets/styles/global.css";

</style>


